const stubRUM = {
    startView: () => { },
    addAction: () => { },
    addError: () => { },
    setUser: () => { },
    setUserProperty: () => { },
    clearGlobalContext: () => { },
};
function getRUM() {
    const rum = window.DD_RUM;
    return rum ?? stubRUM;
}

/**
 * Datadog RUM methods invoked from CodaMetrix app code (not bootstrap/init).
 * Keep in sync with repo usage of `getRUM()` / `window.DD_RUM`.
 */
const CMX_RUM_API_KEYS = [
    'startView',
    'addAction',
    'addError',
    'setUser',
    'setUserProperty',
    'clearGlobalContext',
];

export { CMX_RUM_API_KEYS, getRUM };
//# sourceMappingURL=index.js.map
